import { UseQueryResult, useQuery } from 'react-query';
import { api } from '../api';
import { Invitation } from '../types/invitation';

async function getInvitations(): Promise<{ invitations: Invitation[] }> {
    const { data } = await api.get(`/profile/invitations`);

    return data;
}

export function useInvitations(): UseQueryResult<{ invitations: Invitation[] }, unknown> {
    return useQuery(['profile-invitations'], getInvitations, {
        keepPreviousData: true,
    });
}
